import * as React from 'react'

import { compose, pure } from 'recompose'
import LimitTextField from '../../molecules/LimitTextField/LimitTextField'
import * as styles from './AuthForm.css'

export enum FormType {
  SIGNUP,
  LOGIN
}

interface AuthFormProps {
  email: string
  password: string
  type: FormType
  errors?: any
  handleChangeForm: (params: any) => void
}

const AuthForm: React.FunctionComponent<AuthFormProps> = ({
  email,
  password,
  type,
  handleChangeForm,
  errors = { email: null, password: null }
}) => {
  const handleChange = (data: any) => {
    const current = {
      email,
      password
    }
    handleChangeForm({
      ...current,
      ...data
    })
  }

  return (
    <div className={styles.container}>
      <div className={type === FormType.SIGNUP ? styles.emailForm : styles.emailFormLogin}>
        <LimitTextField
          title="メールアドレス"
          showLimitCount={false}
          placeholder="example@ennoshita.app"
          text={email}
          handleChange={(e: any) => handleChange({ email: e.targetTitle })}
          errorMessage={errors.email}
        />
      </div>
      <div className={type === FormType.SIGNUP ? styles.passwordForm : styles.passwordFormLogin}>
        <LimitTextField
          title="パスワード"
          showLimitCount={false}
          placeholder={type === FormType.SIGNUP ? '半角英数字記号8文字以上' : '*********'}
          text={password}
          type="password"
          handleChange={(e: any) => handleChange({ password: e.targetTitle })}
          errorMessage={errors.password}
        />
      </div>
      {type === FormType.SIGNUP ? (
        <div className={styles.signupNotice}>
          <p className={styles.signupNoticeText}>複数人でennoshitaをご利用予定の方はパスワードの設定にご注意ください</p>
        </div>
      ) : null}
    </div>
  )
}

export default compose<AuthFormProps, AuthFormProps>(pure)(AuthForm)
